import {Stack, Text} from "@mantine/core";
import {ResponsiveLine} from "@nivo/line";

import './styles.scss';
import WidgetNivoBase from "./index";
import NumberUtils from "../../../utils/number.utils";

interface Props {
    title: string,
    data?: any[],
    axisLeftName: string,
    axisBottomName: string,
    tickSize: number,
    tickPadding: number,
    tickRotation: number,
    legendOffset: number,
    axisBottomRotation?: number,
}

function WidgetNivoLine({
                            title,
                            data,
                            axisBottomName,
                            axisLeftName,
                            tickSize,
                            tickPadding,
                            tickRotation,
                            legendOffset
                        }: Props) {

    function renderGraph() {
        if (data) {
            return (
                <ResponsiveLine
                    data={data}
                    margin={{top: 10, right: 20, bottom: 50, left: 60}}
                    xScale={{type: 'point'}}
                    curve="monotoneX"
                    colors="#6CADD9"
                    yScale={{
                        type: 'linear',
                        min: 0,
                        max: 'auto',
                    }}
                    // yFormat=" >-.2f"
                    axisTop={null}
                    axisRight={null}
                    axisBottom={{
                        orient: 'bottom',
                        tickSize: tickSize, //5,
                        tickPadding: tickPadding, //5,
                        tickRotation: tickRotation,
                        legend: axisBottomName,
                        legendOffset: legendOffset, //36,
                        legendPosition: 'middle'
                    } as any}
                    axisLeft={{
                        orient: 'left',
                        tickSize: 5,
                        tickPadding: 5,
                        tickRotation: 0,
                        legend: axisLeftName,
                        legendOffset: -40,
                        legendPosition: 'middle'
                    } as any}
                    pointSize={5}
                    pointColor={{theme: 'background'}}
                    pointBorderWidth={2}
                    pointBorderColor={{from: 'serieColor'}}
                    pointLabelYOffset={-12}
                    enableArea={true}
                    useMesh={true}
                    enableSlices="x"
                    sliceTooltip={({slice}) => {
                        return (
                            <div
                                style={{
                                    background: 'white',
                                    padding: '9px 12px',
                                    border: '1px solid #ccc',
                                }}
                            >
                                {slice.points.map(point => (
                                    <div
                                        key={point.id}
                                        style={{
                                            padding: '3px 0',
                                        }}
                                    >
                                        <div>Date: <strong>{point.data.xFormatted}</strong></div>
                                        <div>{point.serieId}: <strong>{point.data.yFormatted}</strong></div>
                                    </div>

                                ))}
                            </div>
                        )
                    }}
                />
            )
        } else {
            return (
                <Stack align="center">
                    <Text>No Data Found</Text>
                </Stack>
            )
        }
    }

    return (
        <div className="widget-nivo-base">
            <div className='header'>
                <Text>
                    {title}
                </Text>
            </div>
            <div className='widget-chart-container'>
                {renderGraph()}
            </div>
        </div>
    )
}

export default WidgetNivoLine;